module.exports = __webpack_public_path__ + "core-img/fancybox_overlay.8ac1807a77b9f3c1e8cfb2d86294ca28.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/fancybox_overlay.png
// module id = 91
// module chunks = 0